<template>
	<TheForm :model="request" :rules="rules" ref="formRef" :waiting="waiting" :id="id" :labelPosition="'top'">
		<section>
			<ButtonBack />
			<h1>Beschwerdeformular</h1>

			<p>
				Bei Beschwerden über Werbemaßnahmen im Sinne des Ethik-Kodex steht Ihnen der Österreichische Werberat gerne zur Seite. Bitte füllen Sie das
				Formular vollständig aus und laden Sie uns Medien oder Links zu den beanstandeten Werbemaßnahmen hoch. Ihre Beschwerde sollte unter Angabe
				einer genauen Sachverhaltsdarstellung sowie Vorlage des Sujets sowie näheren Bezeichnung des Werbemittels (z.B. Anzeige, Prospekt, Plakat
				etc.) erfolgen.
			</p>
			<p>
				Ihre Beschwerde wird direkt an die Geschäftsstelle weitergeleitet und <strong> selbstverständlich völlig anonym.</strong> Anonyme Beschwerden
				werden nicht bearbeitet. Die Identität der Beschwerdeführer wird vertraulich behandelt und nicht an Dritte weitergegeben. Das Verfahren des
				Österreichischen Werberates ist kostenlos.
			</p>

			<TheBox :title="'1. Kontaktdaten'" :hasDataGrid="false">
				<el-row>
					<el-col :sm="12" :xs="24">
						<el-form-item label="Anrede:" prop="gender">
							<el-select v-model="request.gender" :placeholder="'Bitte wählen'">
								<el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>

						<el-form-item label="Vorname:" prop="firstName">
							<el-input v-model="request.firstName" />
						</el-form-item>

						<el-form-item label="Nachname:" prop="lastName">
							<el-input v-model="request.lastName" />
						</el-form-item>
					</el-col>
					<el-col :sm="12" :xs="24">
						<el-form-item label="E-Mail-Adresse:" prop="email">
							<el-input v-model="request.email" />
						</el-form-item>

						<el-form-item label="Firma:" prop="company">
							<el-input v-model="request.company" />
						</el-form-item>

						<el-form-item label="Telefon:" prop="phone">
							<el-input v-model="request.phone" />
						</el-form-item>
					</el-col>
				</el-row>
			</TheBox>

			<TheBox :title="'2. Grund und Medium'" :hasDataGrid="false" id="categoryAndMedium">
				<p>Bitte geben Sie den Grund bzw. die Kategorie ein, die aus Ihrer Sicht aus dem Ethik-Kodex zutrifft. </p>
				<a
					href="https://www.werberat.at/ethik-kodex-der-%C3%B6sterreichischen-werbewirtschaft"
					target="_blank"
					title="Ethik-Kodex anzeigen"
					class="link"
					>Ethik-Kodex anzeigen</a
				>

				<el-row>
					<el-col :sm="12" :xs="24">
						<el-form-item label="Beschwerdegrund:" prop="category">
							<el-select v-model="selectedCategory" :placeholder="'Bitte wählen'">
								<el-option v-for="option in categoryOptions" :key="option.value.number" :label="option.label" :value="option.value.number" />
							</el-select>

							<!-- <v-select
								v-model="request.category"
								label="label"
								:options="categoryOptions"
								:clearable="false"
								:searchable="false"
								placeholder="Bitte wählen"
							/> -->
						</el-form-item>
					</el-col>

					<el-col :sm="12" :xs="24">
						<el-form-item label="Medium:" prop="medium">
							<el-select v-model="selectedMedium" :placeholder="'Bitte wählen'">
								<el-option v-for="option in mediaOptions" :key="option.value.name" :label="option.label" :value="option.value.name" />
							</el-select>
							<!-- <v-select
								v-model="request.medium"
								label="label"
								:options="mediaOptions"
								:clearable="false"
								:searchable="false"
								:placeholder="'Bitte wählen'"
							/> -->
						</el-form-item>
					</el-col>
				</el-row>
			</TheBox>

			<TheBox :title="'3. Beschwerdetitel und Beschwerdetext'">
				<el-form-item prop="title" label="Beschwerdetitel">
					<el-input v-model="request.title" placeholder="Tragen Sie hier den Titel Ihrer Beschwerde ein" />
				</el-form-item>

				<el-form-item prop="text" label="Beschwerdetext">
					<el-input
						v-model="request.text"
						:autosize="{ minRows: 6 }"
						type="textarea"
						placeholder="Tragen Sie hier den Text Ihrer Beschwerde ein. Erklären Sie gegen welche Kriterien das Werbemittel Ihrer Meinung nach verstößt."
					/>
				</el-form-item>
			</TheBox>
		</section>

		<section>
			<h2>4. Optionale Informationen</h2>
		</section>

		<DetailsMedia :files="request.files ? request.files : []" @addToFiles="addToFiles" @removeFromFiles="removeFromFiles" :pageType="'beschwerde'" />
		<DetailsLinks :links="request.links ? request.links : []" @addToLinks="addToLinks" @removeFromLinks="removeFromLinks" :pageType="'beschwerde'" />

		<section>
			<el-form-item prop="confirmation" label="">
				<el-checkbox v-model="request.confirmation">
					<strong>DSGVO und Mailzustimmung:</strong> {{ texts.werberat.dsgvo }}
					<RouterLink to="/datenschutz" title="Unsere Datenschutzbestimmungen" target="_blank" class="link">
						{{ texts.werberat.dsgvoLinktext }}
					</RouterLink>
				</el-checkbox>
			</el-form-item>

			<p><strong>Hinweis: </strong>{{ texts.werberat.dsgvoHinweis }}</p>

			<TheButton type="danger" @buttonclick="createComplaint()"> Beschwerde senden und Dateien hochladen </TheButton>
		</section>
	</TheForm>

	<DialogLeavePage v-model:open="openClosingDialog" @cancel="leavePage" @save="createComplaint(true)" />
</template>

<script lang="ts">
import ButtonBack from '../components/buttons/ButtonBack.vue';
import ButtonSticky from '../components/buttons/ButtonSticky.vue';
import DialogLeavePage from '../components/dialogs/DialogLeavePage.vue';
import TheBox from '../components/TheBox.vue';
import TheButton from '../components/TheButton.vue';
import TheForm from '../components/TheForm.vue';
import { Delete, Plus, Loading } from '@element-plus/icons-vue';
import InputLite from '../components/forms/InputLite.vue';
import DetailsLinks from './sections/DetailsLinks.vue';
import DetailsMedia from './sections/DetailsMedia.vue';
import { ElMessage, FormInstance } from 'element-plus';
import { computed, defineComponent, ref, markRaw } from 'vue';
import saveIcon from '../assets/icons/saveIcon.vue';
import { returnFormOptions } from '../utils/formOptions.js';
import { texts } from '../utils/texts';
import { ComplaintRequest } from '@/types/formdataTypes';
import { FileDto, LinkDto } from '@/types/types';
import { validateForm, validateCategory, validateMedium, validateCheckbox, hasFormChanged, resetForm } from '@/utils/functions';
import type { RouteLocationRaw } from 'vue-router';
import { createComplaint } from '@/requests/complaints';
import { useStore } from '../store';

const ElMessageDuration = 3000;

interface ComplaintRequestWithConfirmation extends ComplaintRequest {
	confirmation: boolean;
}

interface NewComplaintsData {
	request: ComplaintRequestWithConfirmation;
	initialData: ComplaintRequestWithConfirmation;
	id: string;
	openClosingDialog: boolean;
	waiting: boolean;
	rules: Object;
	checkPageLeave: boolean;
	pageLeaveTo: RouteLocationRaw | null;
}

const initialRequestObj = {
	title: '',
	category: {
		number: '',
	},
	// category: null, // for vue-select
	email: '',
	firstName: '',
	lastName: '',
	gender: null,
	medium: {
		name: '',
	},
	// medium: null,  // for vue-select
	phone: '',
	company: '',
	text: '',
	files: [],
	links: [],
	confirmation: false,
};

export default defineComponent({
	name: 'BeschwerdeNeuPublicView',
	data(): NewComplaintsData {
		return {
			request: initialRequestObj,
			initialData: JSON.parse(JSON.stringify(initialRequestObj)), // deep copy to ensure different objects
			id: 'complaintForm',
			openClosingDialog: false,
			waiting: false,
			rules: {
				title: [{ required: true, message: texts.formErrors.reqMissing, trigger: ['blur'] }],
				gender: [{ required: true, message: texts.formErrors.reqMissing, trigger: 'change' }],
				email: [
					{ required: true, message: texts.formErrors.reqMissing, trigger: 'blur' },
					{ type: 'email', message: texts.formErrors.emailReq, trigger: ['blur'] },
				],
				firstName: [{ required: true, message: texts.formErrors.reqMissing, trigger: 'blur' }],
				lastName: [{ required: true, message: texts.formErrors.reqMissing, trigger: 'blur' }],
				category: [{ required: true, validator: validateCategory, trigger: ['change', 'blur'] }],
				medium: [{ required: true, validator: validateMedium, trigger: 'change' }],
				text: [
					{ required: true, message: texts.formErrors.reqMissing, trigger: ['blur'] },
					{ min: 3, message: texts.formErrors.minChars, trigger: 'blur' },
				],
				confirmation: [{ validator: validateCheckbox, trigger: 'change' }],
			},
			checkPageLeave: true,
			pageLeaveTo: null,
		};
	},
	components: {
		ButtonBack,
		ButtonSticky,
		TheButton,
		TheBox,
		Plus,
		Loading,
		Delete,
		DetailsMedia,
		DetailsLinks,
		saveIcon,
		InputLite,
		TheForm,
		DialogLeavePage,
	},
	setup() {
		const formRef = ref<FormInstance>();
		const store = useStore();
		const loggedin = computed(() => store.state.loggedin);

		return {
			formRef,
			loggedin,
		};
	},
	computed: {
		texts() {
			return texts;
		},
		genderOptions() {
			return returnFormOptions('gender');
		},
		categoryOptions() {
			return returnFormOptions('complaintAndCaseCategories');
		},
		mediaOptions() {
			return returnFormOptions('media');
		},
		selectedCategory: {
			get(): string {
				return this.request?.category?.number || '';
			},
			set(value: string) {
				if (this.request) {
					this.request.category = {
						number: value,
					};
				}
			},
		},
		selectedMedium: {
			get(): string {
				return this.request?.medium?.name || '';
			},
			set(value: string) {
				if (this.request) {
					this.request.medium = {
						name: value,
					};
				}
			},
		},
	},
	methods: {
		async createComplaint(leavePage = false) {
			this.openClosingDialog = false;

			const isValid = await validateForm(this.formRef, this.id);
			if (!isValid) return;

			this.waiting = true;
			const waitingMsg = ElMessage({ message: texts.formErrors.waiting, type: 'info', duration: 0, showClose: false, icon: markRaw(Loading) });

			const createRequest: ComplaintRequest = {} as ComplaintRequest;
			Object.entries(this.request).forEach(([key, val]) => {
				if (key === 'files' || key === 'links') return;
				if (typeof val === 'object' && val && 'value' in val) {
					createRequest[key] = val.value;
				} else {
					createRequest[key] = val;
				}
			});

			if (this.request.links && this.request.links.length > 0) {
				createRequest.links = this.request.links?.map((link) => {
					return {
						name: link.link.name,
						url: link.link.url,
						type: link.link.type,
					} as LinkDto;
				});
			}

			if (this.request.files && this.request.files.length > 0) {
				createRequest.files = this.request.files?.map((file) => {
					return {
						fileName: file.file.fileName,
						bytes: file.file.bytes,
						contentType: file.file.contentType,
					} as FileDto;
				});
			}

			const result = await createComplaint(createRequest);
			if (result.success) {
				if (leavePage) this.leavePage();
				else {
					this.checkPageLeave = false;
					if (this.loggedin) {
						this.$router.push({ name: 'BeschwerdeDetail', params: { id: String(result.data.id) }, replace: true });
					} else {
						this.$router.push({ name: 'BeschwerdeNeuDone', replace: true });
					}
				}
			} else {
				ElMessage({ message: texts.complaints.saveFailed, type: 'error', duration: ElMessageDuration });
			}

			this.waiting = false;
			waitingMsg.close();
		},
		addToFiles(file) {
			if (!this.request.files) this.request.files = [];
			this.request.files.push(file);
		},
		removeFromFiles(file) {
			this.request.files = this.request.files?.filter((f) => f.file !== file.file);
		},
		removeFromLinks(link) {
			this.request.links = this.request.links?.filter((l) => l.link !== link.link);
		},
		addToLinks(link) {
			if (!this.request.links) this.request.links = [];
			this.request.links.push(link);
		},
		leavePage() {
			this.openClosingDialog = false;
			this.checkPageLeave = false;

			// @ts-ignore
			this.$router.push(this.pageLeaveTo);
		},
		validateForm,
		validateCategory,
		handleBeforeRouteLeave(to, from, next) {
			if (this.checkPageLeave === false) {
				resetForm(this.formRef, this.id);
				next();
				return;
			}

			// check if request data has changed
			const hasChanged = hasFormChanged({ initialData: this.initialData, currentData: this.request });

			if (!hasChanged) {
				next();
				return;
			}

			// ABORT NAVIGATION & SHOW DIALOG
			this.openClosingDialog = true;
			this.pageLeaveTo = to;
			next(false);
		},
	},
});
</script>

<style lang="scss" scoped>
@use '../scss/vars.scss' as *;
#beschwerde-anlegen {
	.box {
		margin-top: 3rem;
	}

	section:first-of-type {
		margin-top: 0;
	}

	#categoryAndMedium {
		p {
			margin: 0;
		}
	}

	.el-button:last-child {
		margin-top: 1rem;
	}
}
</style>
